import { z } from 'zod';
import { TIME_STRICT_REGEX } from '@/utils/timeConversion';


export const registerIncidentFormSchema = z.object({
  incidentTypeId: z.string().min(1, 'attendance:incident.validation.incidentTypeRequired'),
  locationId: z.string().min(1, 'attendance:incident.validation.locationRequired'),
  eventId: z.string().min(1, 'attendance:incident.validation.eventRequired'),
  checkInDate: z.string().min(1, 'attendance:incident.validation.dateRequired'),
  checkInTime: z.string().min(1, 'attendance:incident.validation.timeRequired').regex(TIME_STRICT_REGEX, 'attendance:incident.validation.invalidTimeFormat'),
  comment: z.string()
    .max(80, 'attendance:incident.validation.commentMaxLength')
    .refine((val) => val.trim().length > 0, 'attendance:incident.validation.commentRequired'),
});

export type RegisterIncidentFormValues = z.infer<typeof registerIncidentFormSchema>;
